import { type CouponContent, type CouponInformationProps } from '../types/coupon-information.types';
import type { CouponContentResponse } from '../../../types/front.graphql';
import { formatDate } from '../../../utils';
import { getCouponImageUri } from '../../../utils/coupon-image-utils';
import { useMemo } from 'react';

export interface CouponContents extends CouponContentResponse {
    to_date?: string;
    from_date?: string;
}
export const useMapCouponContent = () => {
    const mapContentToCouponInfo = useMemo(() => {
        return (coupon: CouponContents): CouponInformationProps => ({
            id: coupon?.salesrule?.code ?? '',
            startDate: coupon?.salesrule
                ? formatDate(coupon.salesrule.from_date)
                : formatDate?.(coupon?.from_date ?? ''),
            endDate: coupon?.salesrule ? formatDate(coupon.salesrule.to_date) : formatDate?.(coupon?.to_date ?? ''),
            devices: coupon?.device ?? '',
            shippingAddress: coupon?.shipping_method ?? '',
            discount: coupon?.salesrule?.code ?? '',
            condition: coupon?.condition ?? '',
            type: coupon?.tag ?? '',
            progressValue: 0,
            expired: coupon?.salesrule ? formatDate(coupon.salesrule.to_date) : formatDate?.(coupon?.to_date ?? ''),
            productDescription: coupon?.restriction ?? '',
            brand_image: getCouponImageUri(coupon),
            usage_limit: coupon?.salesrule?.usage_limit ?? 0,
            times_used: coupon?.salesrule?.times_used ?? 0,
            name: coupon?.name ?? '',
        });
    }, []);

    const mapContentToCouponDetails = useMemo(() => {
        return (coupon: CouponContentResponse): CouponContent => ({
            title: 'Ưu đãi',
            usageNotice: coupon?.description ?? '',
            validityPeriod: 'Thời gian sử dụng mã',
            devices: 'Thiết bị',
            payment: 'Thanh toán',
            shipping: 'Đơn vị vận chuyển',
            products: 'Sản phẩm',
            learnMore: 'Tìm hiểu thêm',
            paymentDescription: coupon?.payment_method_text ?? '',
        });
    }, []);

    return {
        mapContentToCouponInfo,
        mapContentToCouponDetails,
    };
};
